/** Register type → movement types (frontend-only journal filter). */

export const REGISTER_TYPE_OPTIONS = [
  "Purchase Register",
  "Sales Register",
  "Return Register",
  "Sent Register",
];

export const REGISTER_TYPE_LABEL_KEYS = {
  "Purchase Register": "inventory.purchaseRegister",
  "Sales Register": "inventory.salesRegister",
  "Return Register": "inventory.returnRegister",
  "Sent Register": "inventory.sentRegister",
};

/**
 * Canonical UI movement labels for each register.
 * Includes common aliases so historical / slightly varied API labels still match.
 */
export const REGISTER_TYPE_MOVEMENT_MAP = {
  "Purchase Register": [
    "Purchase from Vendor",
    "Transfer In",
    "Receipt",
    "Customer Demo Inward",
    "Customer_Demo_Inward",
    "Warehouse To Warehouse",
    "Warehouse_To_Warehouse",
  ],
  "Sales Register": [
    "Reservation",
    "Revocation",
    "Outward",
    "Transfer Out",
    "Customer Demo Outward",
    "Customer_Demo_Outward",
    "Material On Loan To Customer",
    "Material_On_Loan_To_Customer",
    "Advance Replacement To Customer",
    "Advance_Replacement_To_Customer",
  ],
  "Return Register": [
    "OEM Warranty Replacement Request from Vendor",
    "OEM Warranty Replacement from Vendor",
    "Defective Replacement Request from Vendor",
    "Defective Replacement from Vendor",
    "Excess Return to Vendor",
    "Return from Customer",
  ],
  "Sent Register": [
    "OEM Warranty Replacement Request to Vendor",
    "Defective Replacement Request to Vendor",
    "Material On Loan To Vendor",
    "Material_On_Loan_To_Vendor",
  ],
};

export function normalizeMovementTypeLabel(type) {
  return String(type || "")
    .replace(/_/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();
}

export function getRegisterTypeMovementSet(registerType) {
  if (!registerType || registerType === "All") return null;
  const labels = REGISTER_TYPE_MOVEMENT_MAP[registerType];
  if (!labels?.length) return null;
  return new Set(labels.map(normalizeMovementTypeLabel));
}

export function rowMatchesRegisterType(row, registerType) {
  const allowed = getRegisterTypeMovementSet(registerType);
  if (!allowed) return true;
  return allowed.has(normalizeMovementTypeLabel(row?.movementType));
}

export function filterJournalByRegisterType(rows, registerType) {
  if (!registerType || registerType === "All") return rows || [];
  return (rows || []).filter((row) => rowMatchesRegisterType(row, registerType));
}
